<template>
  <div>
    <div class="my-information">
      <ul class="right-list">
        <li>
          <span>头像</span>
          <b-form-file accept="image/*" @change="changeAvatar" v-model="request.avatar" class="file-updete" :plain="false" browse-text="上传头像"></b-form-file>
        </li>
        <li>
          <span>昵称</span>
          <b-form-input class="information-input" v-model="request.name" placeholder="昵称"></b-form-input>
        </li>
      </ul>
      <b-button class="submit-file" @click="saveUser" variant="warning" style="margin-left: 200px">保存</b-button>
    </div>
  </div>
</template>
<script>
import { upload } from '@/api/public'
import {profile_update_three} from "@/api/mycenter_studyabroad";
export default {
  name:"UserBase",
  props: {
    user_profile:{
      default: ''
    }
  },
  watch: {
    'user_profile': {
      handler(val, oldVal) {
        this.request = val
      },
      immediate: true,
      deep: true
    }
  },
  data () {
    return {
      request: {
        avatar: '',
        name: ''
      }
    };
  },
  computed: {
  },
  methods: {
    changeAvatar () {
      // 上传文件
      let that = this
      setTimeout(function () {
        that.uploadFile()
      }, 100)
    },
    uploadFile () {
      // 图片上传
      const formser = new FormData() // 获取表单的参数
      formser.append('path', 'web_file')
      formser.append('file', this.request.avatar)
      upload(formser)
        .then(response => {
          this.request.avatar = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    saveUser () {
      profile_update_three({name: this.request.name, avatar: this.request.avatar})
        .then(response => {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mycenter/component/user_base.vue